/* eslint-disable no-undef */
/* eslint-disable object-shorthand */
import { client, partnerClient } from "./client";

export const getCredencials = params => client.post("/sessions", params);

export const getStyles = params => partnerClient.get("/partner", { params });

export const validateCode = params => client.post("/sessions/code_validate", params);

const login = (username, password) => {
  // console.log(username);
  // console.log(password);
};

export default login;
